<template>
  <div class="wrapper">
    <div class="top-nav">
      <div>
        <nav-common :nav="nav"></nav-common>
      </div>
    </div>
    <div class="list">
      <list-item
        v-for="item in partyList"
        :key="'new'+item.id"
        :itemData="item"
        @toPage="getDetail"
      ></list-item>
    </div>
    <div>
      <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
    </div>
  </div>
</template>
<style scoped>
.top-nav {
  width: 100%;
  display: flex;
}
.search {
  width: 310px;
  margin-right: 30px;
}
.list {
  width: 100%;
  border-width: 20px 1px 1px 1px;
  border-style: solid;
  border-color: #e6ecf2;
  padding: 40px 30px;
  box-sizing: border-box;
  border-radius: 10px;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import listItem from "@/components/views/common/listItem.vue";
import ModelPage from "@/components/views/common/ModelPage";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      nav: {
        firsttitle: "",
        firstrouteName: "",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      search_word: "",
      ariList: [], //分页所需的值
      partyList: [],
      page: 1,
      count: 10
    };
  },
  computed: {
    ...mapGetters(["searchVuex"])
  },
  methods: {
    ...mapActions(["setSearch"]),
    getpartyList() {
      const params = {
        type: this.$route.query.section,
        page: this.page,
        count: this.count,
        search_word: this.search_word
      };
      userApi.getpartyList(params).then(res => {
        this.ariList = res.data;
        this.partyList = res.data.list;
        if (this.ariList.total == "1") {
          this.$router.push({
            name: "comPartyDetail",
            query: {
              section: this.$route.query.section,
              id: this.partyList[0].id
            }
          });
        }
      });
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.getpartyList();
    },
    getDetail(id) {
      this.$router.push({
        name: "comPartyDetail",
        query: {
          section: this.$route.query.section,
          id: id
        }
      });
    },
    handleRoute() {
      this.count = 10;
      this.page = 1;
      if (!this.$route.query.section) {
        this.$router.push({
          name: "comPartyList",
          query: {
            section: "1"
          }
        });
      }
      if (this.$route.query.section == "2") {
        this.nav.firsttitle = "党建动态";
      } else if (this.$route.query.section == "3") {
        this.nav.firsttitle = "党风廉政";
      } else if (this.$route.query.section == "4") {
        this.nav.firsttitle = "群团建设";
      } else if (this.$route.query.section == "5") {
        this.nav.firsttitle = "图片新闻";
      } else {
        this.nav.firsttitle = "专题活动";
      }
    }
  },
  components: {
    navCommon,
    listItem,
    ModelPage
  },
  watch: {
    $route() {
      this.handleRoute();
      this.getpartyList();
    },
        searchVuex(newArr, oldArr) {
      this.search_word = newArr;
      if (this.search_word == "") {
        this.getpartyList();
      }
      this.getpartyList();
    }
  },
  mounted() {
    this.handleRoute();
    this.getpartyList();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/ComParty/list.vue